<template>

  <div class="ui padded grid">

    <nav-back-office-top></nav-back-office-top>

    <div class="sixteen wide column">
      <router-link :to="{ name: 'PageActionPlanCreate' }">
        <div class="ui primary button" style="display: inline;">
          <i class="plus icon"></i>
          Add New Action
        </div>
      </router-link>
      &nbsp;&nbsp;&nbsp;
      <plan-template-create
        :type="'action'"
      ></plan-template-create>
      &nbsp;&nbsp;&nbsp;
      <h2>All Actions</h2>

      <div class="ui left labeled fluid icon input">
        <div class="ui label">
          <i class="child icon"></i> Search for Actions
        </div>
        <input type="text" placeholder="You can search by short name, title or description" v-model="filterActionCriteria">
        <i class="search icon"></i>
      </div>

    </div>


    <action-plan-r-u-d
      v-for="action in filteredActionsArray"
      :key="action.id"
      :action="action"
    ></action-plan-r-u-d>

  </div>

</template>

<script>
  import { mapState } from 'vuex'

  import NavBackOfficeTop from '../NavBackOfficeTop'
  import ActionPlanRUD from './ActionPlanRUD'
  import PlanTemplateCreate from './PlanTemplateCreate.vue'

	export default {
    components: {
      NavBackOfficeTop, ActionPlanRUD, PlanTemplateCreate
    },
		data() {
			return {
        filterActionCriteria: null
			}
		},
    computed: {
      ...mapState(['coachingActionsAll']),

      filteredActionsArray: function() {

        if (this.filterActionCriteria === null || this.filterActionCriteria.length === 0){
          return this.dynamicNestedSort("-data.lastModifiedTime", this.coachingActionsAll );
        }

        else {
          let searchResultsbyShortName;
          let searchResultsbyTitle;
          let searchResultsbyBody;

          searchResultsbyShortName = this.coachingActionsAll.filter(action => action.data.shortName.toString().toLowerCase().includes(this.filterActionCriteria.toString().toLowerCase()) );
          searchResultsbyTitle = this.coachingActionsAll.filter(action => action.data.title.toString().toLowerCase().includes(this.filterActionCriteria.toString().toLowerCase()) );
          searchResultsbyBody = this.coachingActionsAll.filter(action => action.data.body !== null && action.data.body.toString().toLowerCase().includes(this.filterActionCriteria.toString().toLowerCase()) );

          let mergedSearchResults = searchResultsbyShortName.concat(searchResultsbyTitle).concat(searchResultsbyBody);

          let searchResults = new Set(mergedSearchResults);

          //Reference: https://stackoverflow.com/questions/20069828/how-to-convert-set-to-array
          return this.dynamicNestedSort("-data.lastModifiedTime", Array.from(searchResults) );
        }
      }
    }

	}
</script>

<style scoped>

  /*-------------------
MB Colour Theme
--------------------*/

  /*.ui.inverted.top.attached.segment {*/
  /*background-color:  #f2711c !important;*/
  /*border-radius-bottomleft:0em;*/
  /*}*/

  .ui.inverted.attached.segment,
  .ui.inverted.tiny.message,
  .ui.inverted.attached.clearing.segment {
    background-color:  #222a34 !important;
  }


  .ui.inverted.attached.clearing.segment {
    border-radius:0.5em;
  }

  /* Switch */
  .ui.toggle.checkbox .box:before,
  .ui.toggle.checkbox label:before {
    color: white !important;
    background: #334c5f;
  }

  .ui.toggle.checkbox .box:hover::before,
  .ui.toggle.checkbox label:hover::before {
    -webkit-tap-highlight-color: transparent;
    background: #334c5f;
  }

  /* Focus */
  .ui.toggle.checkbox input:focus ~ .box:before,
  .ui.toggle.checkbox input:focus ~ label:before {
    background-color: #334c5f;
    border: none;
  }

  /* Active Checkbox */
  .ui.toggle.checkbox input:checked ~ .box,
  .ui.toggle.checkbox input:checked ~ label {
    color: white !important;
  }

  .ui.toggle.checkbox input:checked ~ .box:before,
  .ui.toggle.checkbox input:checked ~ label:before {
    background-color: #26deca !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/content/TabActionPlan.vue